import { f as c, d as _, h as V, i as h } from "./CSSMotionList.js";
import C from "react";
import { S as F } from "./omit.js";
function i(e) {
  return e !== void 0;
}
function R(e, n) {
  var r = n || {}, a = r.defaultValue, t = r.value, y = r.onChange, s = r.postState, S = c(function() {
    return i(t) ? t : i(a) ? typeof a == "function" ? a() : a : typeof e == "function" ? e() : e;
  }), l = _(S, 2), o = l[0], v = l[1], u = t !== void 0 ? t : o, m = s ? s(u) : u, x = V(y), M = c([u]), d = _(M, 2), p = d[0], E = d[1];
  h(function() {
    var f = p[0];
    o !== f && x(o, f);
  }, [p]), h(function() {
    i(t) || v(t);
  }, [t]);
  var A = V(function(f, g) {
    v(f, g), E([u], g);
  });
  return [m, A];
}
const T = (e) => {
  const n = C.useContext(F);
  return C.useMemo(() => e ? typeof e == "string" ? e ?? n : typeof e == "function" ? e(n) : n : n, [e, n]);
};
export {
  T as a,
  R as u
};
